import { ReactElement } from 'react';

import { Tooltip } from './Tooltip';

interface ConditionalToolTipProps {
  isVisible: boolean;
  title: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  children: ReactElement;
}

export const ConditionalToolTip = ({ isVisible, title, placement, children }: ConditionalToolTipProps) =>
  isVisible ? (
    <Tooltip title={title} placement={placement}>
      {children}
    </Tooltip>
  ) : (
    children
  );
